document.addEventListener('click', event => {
  const routeLink = event.target.closest('a[href="/#trips"], a[href="#trips"], a[href="/#roadbook"], a[href="#roadbook"]');
  if (!routeLink || location.pathname !== '/') return;

  const targetId = routeLink.getAttribute('href').split('#')[1];
  const target = document.getElementById(targetId);
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  window.history.replaceState(null, '', `#${targetId}`);
});

document.addEventListener('submit', async event => {
  const form = event.target;

  if (form.matches('[data-newsletter]')) {
    const button = form.querySelector('button');
    if (button) button.textContent = "You're in";
    return;
  }

  if (!form.matches('[data-quick-add]')) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Cart add failed');

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(response => response.json());
    const cartLink = document.querySelector('.nav-cart');
    if (cartLink) cartLink.textContent = `${cartLink.dataset.cartLabel || 'Cart'} · ${cart.item_count}`;
    button.textContent = 'Added';
  } catch (error) {
    button.textContent = 'Try again';
  }

  window.setTimeout(() => {
    button.disabled = false;
    button.textContent = originalLabel;
  }, 1800);
});
